import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {Line} from "rc-progress";
import Views from "./Views";

export default class Realism extends PureComponent {
  static propTypes = {
    progress: PropTypes.number,
    views: PropTypes.object
  };
  render() {
    const {progress, views} = this.props;
    return (
      <React.Fragment>
        {progress < 100 && (
          <Line
            percent={progress}
            strokeWidth="1"
            style={{height: `10px`, width: `350px`}}
            strokeColor="#03a9f4"
          />
        )}
        {views && <Views views={views} />}
      </React.Fragment>
    );
  }
}
